import React from 'react'
import './EAChip.scss'

interface IProps {
  /**
   * Tekst wyświetlany w chipie (automatycznie uppercase)
   */
  label: string;
  
  /**
   * Ikona wyświetlana przed tekstem (opcjonalna)
   */
  icon?: React.ReactNode;
  
  /**
   * Wartość wyświetlana w badge (kropka z cyferką) (opcjonalna)
   */
  badge?: string | number;
  
  /**
   * Wariant stylu chipu
   */
  variant?: 'default' | 'error' | 'warning' | 'success' | 'primary' | 'secondary' | 'dark';
  
  /**
   * Funkcja wywoływana po kliknięciu
   */
  onClick?: () => void;
  
  /**
   * Czy chip jest wyłączony
   */
  disabled?: boolean;
  
  /**
   * Dodatkowa klasa CSS
   */
  className?: string;
}

/**
 * Uniwersalny komponent chip-a
 * 
 * Przykłady użycia:
 * <EAChip label="Aktywny" variant="success" />
 * <EAChip label="Błąd" variant="error" icon={<ErrorIcon />} />
 * <EAChip label="2 elementy" badge={2} variant="primary" />
 */
const EAChip: React.FC<IProps> = ({
  label,
  icon,
  badge,
  variant = 'default',
  onClick,
  disabled = false,
  className = '',
}) => {
  return (
    <div
      className={`chip chip--${variant} ${disabled ? 'chip--disabled' : ''} ${className}`.trim()}
      onClick={!disabled ? onClick : undefined}
      role="button"
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
    >
      {icon && <span className="chip__icon">{icon}</span>}
      <span className="chip__text">{label}</span>
      {badge && <div className="chip__badge">{badge}</div>}
    </div>
  )
}

export default EAChip